/**
 * PayPal checkout helpers for FE pay flows (servers, POS, model access).
 */

/** Absolute http(s) approve URL from PayPal — reject in-app routes. */
export function isPayPalApproveUrl(url: unknown): url is string {
  return typeof url === "string" && /^https?:\/\//i.test(url.trim());
}

/**
 * Redirect the browser to PayPal's approve URL.
 * @throws if the URL is missing or not absolute http(s)
 */
export function redirectToPayPalApprove(approveUrl: unknown): void {
  if (!isPayPalApproveUrl(approveUrl)) {
    throw new Error("PayPal approve link was missing or invalid. Please try again.");
  }
  window.location.assign(approveUrl.trim());
}

export type PayPalCheckoutPayload = {
  approve_url?: string;
  paypal_order_id?: string;
  status?: string;
};
